import { render, staticRenderFns } from "./AdminCenter.vue?vue&type=template&id=48fcc1c0&"
import script from "./AdminCenter.vue?vue&type=script&lang=js&"
export * from "./AdminCenter.vue?vue&type=script&lang=js&"
import style0 from "./AdminCenter.vue?vue&type=style&index=0&id=48fcc1c0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports